import { Box, Tooltip } from "@mui/material";
import React from "react";
import {
  getPlatformColor,
  getPlatformDisplayName,
  getSocialMediaIcon,
  groupUrlsByPlatform,
  normalizeUrl,
  SocialMediaPlatform,
} from "../../utils/socialMediaUtils";

interface SocialMediaIconsProps {
  directories: string[] | null;
  maxIconsPerPlatform?: number;
}

const SocialMediaIcons: React.FC<SocialMediaIconsProps> = ({
  directories,
  maxIconsPerPlatform = 3,
}) => {
  if (!directories || directories.length === 0) {
    return null;
  }

  const groupedUrls = groupUrlsByPlatform(directories);
  const platforms = Object.keys(groupedUrls) as SocialMediaPlatform[];

  if (platforms.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}
    >
      {platforms.map((platform) => {
        const urls = groupedUrls[platform];
        const IconComponent = getSocialMediaIcon(platform);
        const platformColor = getPlatformColor(platform);
        const displayName = getPlatformDisplayName(platform);

        // Show up to maxIconsPerPlatform icons for each platform
        const urlsToShow = urls.slice(0, maxIconsPerPlatform);

        return urlsToShow.map((url, index) => (
          <Tooltip
            key={`${platform}-${index}`}
            title={`${displayName}: ${url}`}
            arrow
            placement="top"
          >
            <Box
              component="span"
              onClick={() =>
                window.open(normalizeUrl(url), "_blank", "noopener,noreferrer")
              }
              sx={{
                display: "inline-flex",
                cursor: "pointer",
                fontSize: 20,
                color: "text.secondary",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  color: platformColor,
                  transform: "scale(1.1)",
                },
              }}
            >
              <IconComponent />
            </Box>
          </Tooltip>
        ));
      })}
    </Box>
  );
};

export default SocialMediaIcons;
